import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20adda21&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20adda21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20adda21')) {
      api.createRecord('20adda21', component.options)
    } else {
      api.reload('20adda21', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20adda21&scoped=true", function () {
      api.rerender('20adda21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/seckill/seckillConfig/index.vue"
export default component.exports